import { Component } from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { ContractService } from '../service/contract.service';

@Component({
  selector: 'app-contract-feedback',
  templateUrl: './contract-feedback.component.html',
  styleUrl: './contract-feedback.component.scss'
})
export class ContractFeedbackComponent {

  feedbackListData:any[]=[];
  total_records:any;
  bodySpinner:boolean=false;
   feedbackPayload:any;
   clientList:any;
   client_id:any;
   pageNo:number=0;
   limit:number=25;
  constructor(private infosecService:ContractService){}

  ngOnInit(){
    
       this.infosecService.getCurrentUser().subscribe({
          next:(response:any)=>{
            this.client_id = response['client_id'][0];
            this.pageNo = 1;
            this.getFeedback();
          },
          error:(errors:HttpErrorResponse)=>{}
        });
   
  }

  ngAfterViewInit(){
       
  }

  getFeedback(){
      this.feedbackPayload = {
        "client_id":this.client_id,   
        "page":this.pageNo,
        "limit":this.limit,
        "filters": []
      }

      this.bodySpinner=true;

    this.infosecService.botQueryFeedback(this.feedbackPayload).subscribe({
      next:(response:any)=>{
         this.bodySpinner=false;
          this.feedbackListData = response['result']['items'];
          if(response['result']['items'].length > 0){
           this.total_records = response['result']['pagination']['total_records'];
         }
      },
      error:(errors:HttpErrorResponse)=>{
          this.bodySpinner=false;
      }
    });

  }

    getSourcedoc_names(document_list: any) {
    let files_name:any = [];
    if (document_list && document_list.length > 0) {
      document_list.forEach((doc_key: any) => {
        if (doc_key["document_name"]) {
          if (files_name.indexOf(doc_key["document_name"]) == -1) {
            files_name.push(doc_key["document_name"]);
          }
        }
      });

      return files_name.join(", ");
    }
  }

  pageChanged(event:any){
     this.pageNo = event;
     this.getFeedback();
  }



}
